import { useEffect, useMemo } from "react";

import {
    FEMALE_BODY_INJURES_IMG_SELECTED,
    MALE_BODY_INJURES_IMG_SELECTED,
} from "@/constants/body-injures";
import { QUESTIONS_IDS } from "@/constants/questionsIds";
import { preloadImages } from "@/hooks/usePreloadImg";
import { useGender } from "@/utils/GenderProvider";

export const usePreloadTargetAreasImages = (questionId?: QUESTIONS_IDS) => {
    const { isFemale } = useGender();
    const images = useMemo(
        () =>
            Object.values(
                isFemale ? FEMALE_BODY_INJURES_IMG_SELECTED : MALE_BODY_INJURES_IMG_SELECTED
            ),
        [isFemale]
    );
    useEffect(() => {
        if (questionId === QUESTIONS_IDS.TARGET_AREAS) {
            preloadImages(images);
        }
    }, [questionId, images]);
};
